export const initYoutubeVideos = () => {
  const youtube_videos_selector = '.youtube';
  const youtube = document.querySelectorAll(youtube_videos_selector);

  for (let i = 0; i < youtube.length; i++) {
    let image = new Image();
    image.src = youtube[i].dataset.holder ? youtube[i].dataset.holder : '';
    image.alt = youtube[i].dataset.alt ? youtube[i].dataset.alt : '';
    image.loading = 'lazy';
    image.addEventListener(
      'load',
      (function () {
        youtube[i].appendChild(image);
      })(i),
    );

    youtube[i].addEventListener('click', function () {
      let iframe = document.createElement('iframe');

      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute(
        'src',
        'https://www.youtube.com/embed/' + this.dataset.embed + '?rel=0&showinfo=0&autoplay=1&enablejsapi=1',
      );

      this.innerHTML = '';
      this.appendChild(iframe);
    });
  }

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          const iframe = entry.target.querySelector('iframe');
          if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        }
      });
    },
    { threshold: 0 },
  );

  youtube.forEach(video => observer.observe(video));
};
